import { HttpClient } from '@angular/common/http';
import {Translation, TRANSLOCO_CONFIG, TRANSLOCO_LOADER, translocoConfig, TranslocoLoader, TranslocoModule} from '@ngneat/transloco';
import {Injectable, NgModule} from '@angular/core';
import {locals} from "./common";
import {Lib} from "../libs/Lib";
import {retryWithBackoff} from "../libs/rxjs/retryWithBackoff";

// same pattern the rest of the app uses to read the build version
const {version: appVersion} = require('../../package.json');

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {

    constructor(private http: HttpClient) {
    }

    getTranslation(lang: string) {
        /*
         * Keyed on the app version, NOT Math.random().
         *
         * A random key made every request a brand new URL, so this ~126KB file could never be
         * served from the browser cache OR from the service worker's own i18n cache - it was
         * re-downloaded in full on every single page load, and only started downloading after
         * Angular had booted. That is what left the UI painted with empty labels for seconds.
         *
         * The version still changes on every deploy (gulp bumps it), so a translation change is
         * picked up immediately, but within a release the file caches normally.
         */
        const url = `./assets/i18n/${lang}.json?v=${appVersion}`;
        return this.http.get<Translation>(url)
            .pipe(retryWithBackoff(url, null, null));
    }
}

@NgModule({
    exports: [TranslocoModule],
    providers: [
        {
            provide: TRANSLOCO_CONFIG,
            useValue: translocoConfig({
                availableLangs: locals,
                fallbackLang: 'en',
                defaultLang: 'en',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                missingHandler: {
                    useFallbackTranslation: true,
                    logMissingKey: false
                },
                prodMode: !Lib.DevMode(),
            })
        },
        {provide: TRANSLOCO_LOADER, useClass: TranslocoHttpLoader}
    ]
})
export class TranslocoRootModule {
}
